<template>
  <div class="activity-rule-root">
    <div class="custom-nav-block" :class="[scrollTop ? 'nav-scrolling' : 'nav-default']" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" :title="$t('lang.ActCommon.k009')" left-arrow @click-left="goPrevious" @click-right="noopNavRight">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow00.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="mayday-main">
      <div class="rules-scroll">
        <!-- Event window -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.ActCommon.k025') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">1.</span>
              {{ $t('lang.ActCommon.k026') }}：
            </p>
            <p v-if="eventDurationLine" class="rule-highlight">{{ eventDurationLine }}</p>
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">2.</span>
              {{ $t('lang.ActCommon.k092') }}
            </p>
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">3.</span>
              {{ $t('lang.MayDay2026.k076') }}
            </p>
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">4.</span>
              {{ $t('lang.MayDay2026.k077') }}
            </p>
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">5.</span>
              {{ $t('lang.MayDay2026.k078') }}
            </p>
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">6.</span>
              {{ $t('lang.MayDay2026.k079') }}
            </p>
          </div>
        </section>

        <!-- How to Earn Rewards -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.MayDay2026.k044') }}</h2>
          <p class="rule-p rule-p--numbered">
            <span class="rule-p__idx">1.</span>
            {{ $t('lang.MayDay2026.k045') }}
          </p>
          <div class="rule-call-lines">
            <p class="rule-call-line">
              <span class="rule-call-line__bold">{{ $t('lang.MayDay2026.k046') }}</span>
            </p>
            <p class="rule-call-line">
              <span class="rule-call-line__bold">{{ $t('lang.MayDay2026.k047') }}</span>
            </p>
            <p class="rule-call-line">
              <span class="rule-call-line__bold">{{ $t('lang.MayDay2026.k048') }}</span>
            </p>
            <p class="rule-call-line">
              <span class="rule-call-line__bold">{{ $t('lang.MayDay2026.k049') }}</span>
            </p>
          </div>
          <p class="rule-p rule-p--numbered rule-p--tip">
            <span class="rule-p__idx">2.</span>
            {{ $t('lang.MayDay2026.k050') }}
          </p>
        </section>

        <!-- Task Settlement Rules -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.MayDay2026.k051') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p">{{ $t('lang.MayDay2026.k052') }}</p>
            <p class="rule-p">{{ $t('lang.MayDay2026.k053') }}</p>
            <p class="rule-p rule-p--tip">{{ $t('lang.MayDay2026.k054') }}</p>
          </div>
        </section>

        <!-- Daily Tasks -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.MayDay2026.k055') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p">{{ $t('lang.MayDay2026.k056') }}</p>
            <p class="rule-p">{{ $t('lang.MayDay2026.k057') }}</p>
          </div>
        </section>

        <!-- 3-Day Streak Tasks -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.MayDay2026.k035') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p">{{ $t('lang.MayDay2026.k058') }}</p>
            <p class="rule-p">{{ $t('lang.MayDay2026.k059') }}</p>
            <p class="rule-p">{{ $t('lang.MayDay2026.k060') }}</p>
          </div>
        </section>

        <!-- Repeatable Tasks -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.MayDay2026.k037') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p">{{ $t('lang.MayDay2026.k061') }}</p>
            <p class="rule-p">{{ $t('lang.MayDay2026.k062') }}</p>
          </div>
        </section>

        <!-- Lucky Draw Rules -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.MayDay2026.k063') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p">{{ $t('lang.MayDay2026.k064') }}</p>
            <p class="rule-p">{{ $t('lang.MayDay2026.k065') }}</p>
            <p class="rule-p">{{ $t('lang.MayDay2026.k066') }}</p>
          </div>
        </section>

        <!-- Leaderboard Rules -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.MayDay2026.k067') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p">{{ $t('lang.MayDay2026.k068') }}</p>
            <p class="rule-p">{{ $t('lang.MayDay2026.k069') }}</p>
            <p class="rule-p">{{ $t('lang.MayDay2026.k070') }}</p>
            <p class="rule-p">{{ $t('lang.MayDay2026.k071') }}</p>
          </div>
        </section>

        <!-- Important Notes -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.MayDay2026.k072') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p">{{ $t('lang.MayDay2026.k073') }}</p>
            <p class="rule-p">{{ $t('lang.MayDay2026.k074') }}</p>
            <p class="rule-p">{{ $t('lang.MayDay2026.k075') }}</p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { maleSpinHome } from './apidir/api.js'

export default {
  data() {
    return {
      actStartTime: '',
      actEndTime: '',
      rankAnnounceLine: '',
      boardData: {
        num1Reward: 1200,
        num2Reward: 800,
        num3Reward: 500,
        num4Reward: 100,
      },
    }
  },
  computed: {
    eventDurationLine() {
      if (!this.actStartTime || !this.actEndTime) return ''
      return `${this.actStartTime} - ${this.actEndTime}`
    },
  },
  methods: {
    noopNavRight() {},
    fetchData() {
      maleSpinHome().then((resData) => {
        if (resData && !resData.error) {
          if (resData.eventStartTimestamp) {
            this.actStartTime = this.handleMoment(resData.eventStartTimestamp, 'YYYY-MM-DD HH:mm:ss')
          }
          if (resData.eventEndTimestamp) {
            const endMs = Number(resData.eventEndTimestamp)
            this.actEndTime = this.handleMoment(endMs, 'YYYY-MM-DD HH:mm:ss')
          }
          const rr = resData.rankRewards
          if (rr && typeof rr === 'object') {
            this.boardData = {
              num1Reward: rr.first != null ? rr.first : this.boardData.num1Reward,
              num2Reward: rr.second != null ? rr.second : this.boardData.num2Reward,
              num3Reward: rr.third != null ? rr.third : this.boardData.num3Reward,
              num4Reward: rr.fourthToTenth != null ? rr.fourthToTenth : this.boardData.num4Reward,
            }
          }
          if (resData.rankAnnounceStart && resData.rankAnnounceEnd) {
            this.rankAnnounceLine = `${resData.rankAnnounceStart} - ${resData.rankAnnounceEnd}`
          } else if (resData.eventEndTimestamp) {
            const endMs = Number(resData.eventEndTimestamp)
            const endAnnounce = this.handleMoment(endMs + 86400000, 'YYYY-MM-DD HH:mm:ss')
            this.rankAnnounceLine = `${this.actEndTime} - ${endAnnounce}`
          }
        }
      })
    },
  },
  created() {
    this.fetchData()
  },
  mounted() {
    document.body.scrollTo({ top: 0 })
  },
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.activity-rule-root {
  width: 100%;
  min-height: 100vh;
  background: #0da1fe;

  .custom-nav-block {
    background: #0da1fe;

    &.nav-scrolling {
      background: rgba(13, 161, 254, 0.95);
    }
  }

  .left-nav,
  .right-nav {
    width: 24px;
    height: 24px;
    display: block;
  }

  .mayday-main {
    position: relative;
  }

  .rules-scroll {
    padding: 16px 10px 32px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 375px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .rule-card {
    width: 100%;
    padding: 16px;
    border-radius: 12px;
    background: #f9fff5;
    box-sizing: border-box;
  }

  .rule-card__title {
    margin: 0 0 8px;
    font-family: 'TikTokSans-Regular', sans-serif;
    font-weight: 800;
    font-size: 17px;
    line-height: 22px;
    color: #0081b3;
  }

  .rule-card__block {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .rule-card__stack {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .rule-p {
    margin: 0;
    font-family: 'TikTokSans-Regular', sans-serif;
    font-size: 15px;
    line-height: 22px;
    color: #0081b3;
  }

  .rule-p--numbered {
    display: block;
  }

  .rule-p__idx {
    font-weight: 600;
  }

  .rule-p--tip {
    color: #0081b3;
    opacity: 0.92;
  }

  .rule-p--flush {
    margin-bottom: 0;
  }

  .rule-highlight {
    margin: 0;
    font-family: 'TikTokSans-Regular', sans-serif;
    font-weight: 600;
    font-size: 15px;
    line-height: 22px;
    color: #ff6224;
  }

  .rule-announce {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .rule-call-lines {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 4px 0 8px;
  }

  .rule-call-line {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 5px;
    font-size: 17px;
    line-height: 22px;
    color: #0081b3;
  }

  .rule-call-line__bold {
    font-family: 'TikTokSans-Regular', sans-serif;
    font-weight: 800;
  }

  .rule-call-line__light {
    font-family: 'Roboto-Regular', sans-serif;
    font-weight: 400;
    font-size: 17px;
    color: #0081b3;
  }

  .rule-p--pool-silver-full {
    margin: 0;
    font-family: 'TikTokSans-Regular', sans-serif;
    font-size: 17px;
    line-height: 22px;
    font-weight: 700;
    color: #0081b3;
  }

  .rule-p--pool-gold {
    margin: 0;
    font-size: 17px;
    line-height: 22px;
    color: #0081b3;
  }

  .rule-p ::v-deep b {
    font-weight: 800;
  }

  .rule-reward-list {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .rule-reward-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .rule-reward-rank {
    font-family: 'TikTokSans-Regular', sans-serif;
    font-size: 17px;
    color: #0081b3;
  }

  .rule-reward-val {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: 'TikTokSans-Regular', sans-serif;
    font-weight: 800;
    font-size: 17px;
    color: #0081b3;
  }

  .rule-reward-coin {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: 'TikTokSans-Regular', sans-serif;
  font-weight: 600;
  color: #ffffff;
}

::v-deep .van-nav-bar {
  background: transparent;
}

::v-deep .van-nav-bar .van-icon {
  color: #fff;
}
</style>
